/**
 * Section: Featured collection
 * ------------------------------------------------------------------------------
 * Configured section to display a single collection in product cards
 * - includes enable slider option
 *
 * @namespace featuredCollection
 */
import {register} from '@shopify/theme-sections';

import Carousel from '../components/carousel';
import QuickView from '../components/quick-view';

/**
 * DOM selectors.
 */
const selectors = {
  container: '[js-featured-collection="carousel"]',
  cell: '[js-featured-collection="slide"]',
};

/**
 * Register a single featured collection section.
 * Executes on page load as well as Theme Editor `section:load` events.
 * @param {string} container - Selector for the section container DOM element.
 */
register('featured-collection', {

  /**
   * Set Event Bus listeners to trigger resize when ready.
   */
  setEventBusListeners() {
    Frame.EventBus.listen(`Carousel-FeaturedCollection-${this.id}:settle`, () => {
      this.cache.carousel.resize();
    });
  },

  /**
   * Cache selectors.
   * - Define necessary variables and make available for component use.
   */
  cacheSelectors() {
    const carousel = {};
    const container = `[data-section-id="${this.id}"] ${selectors.container}`;
    const cells = `[data-section-id="${this.id}"] ${selectors.cell}`;

    this.cache = {
      carousel,
      container,
      cells,
    };
  },

  /**
   * Construct carousel using imported Carousel component.
   */
  constructCarousel() {
    this.cache.carousel = Carousel(this.cache.container, {
      cellSelector: this.cache.cells,
      pageDots: true,
      prevNextButtons: true,
    });

    this.cache.carousel.init();
  },

  /**
   * Construct new carousel on `section:load`.
   */
  onLoad() {
    QuickView().init();
    this.cacheSelectors();
    this.setEventBusListeners();
    this.constructCarousel();
  },
});
